module.exports = __webpack_public_path__ + "images/HotspotDefault_v3.svg";